<template lang="pug">
  div.header-bubbles-container
    //- 签到弹窗悬浮球
    .sign-in-bubble-area(v-if="signInList.length > 0")
      SignInBubble(
        :signData="nextSignData"
        @bubbleClick="handleSignBubbleClick"
      )
    //- 单单返悬浮球
    AwardLevitatedSphere(
      v-if="!pureVersion"
      :rewardCount="rewardCount"
      :isDueSoon="isDueSoon"
      @awardClick="handleAwardClick"
    )

    //- 单单返奖励引导弹窗
    AwardGuidePopup(
      :visible="awardGuidePopupVisible"
      :list="taskAwardList"
      :extInfo="taskAwardExtInfo"
      @close="handleAwardGuidePopupClose"
    )
</template>

<script>
import { getVersion } from '@/utils/systemCode';
import eventBus from '@/const/eventBus';
import { Storage } from '@/utils/storage';
import Loading from '@/components/loading';
import Toast from '@/components/toast';
import { compareVersions, safeJsonStringify } from '@/utils/tools';
import {
  signInListAdapter,
  loadAndShowSignPopup,
  getTaskAwardListData,
} from '../common/helper';
import SignInBubble from './sign-in-bubble.vue';
import AwardLevitatedSphere from './award-levitated-sphere.vue';
import AwardGuidePopup from './award-guide-popup.vue';
import {
  WELFARE_VERSION,
  AWARD_COIN_STATUS,
  STORAGE_KEY_SHOW_AWARD_GUIDE,
  FULI_MODULE,
} from '../consts';

export default {
  name: 'HeaderBubbles',
  components: {
    SignInBubble,
    AwardLevitatedSphere,
    AwardGuidePopup,
  },
  props: {
    // 单单返奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
    // 是否是纯净版页面
    pureVersion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 签到计划列表
      signInList: [],
      // 是否为会员
      currentlyIsVip: false,
      // 明天的签到信息
      nextSignData: {},
      // 单单返奖励引导弹窗是否显示
      awardGuidePopupVisible: false,
      // 单单返任务奖励列表
      taskAwardList: [],
      // 翻倍广告id和信息
      doubleInformation: null,
      // 单单返浮层拓展信息
      taskAwardExtInfo: {},
      // 是否在支付宝已签到
      isSignedAlipay: false,
      // 是否展示签到更新提示
      showUpdateTips: false,
      // 重复签到提示文案
      repeatSignDesc: '',
    };
  },
  inject: ['taskScene'],
  mounted() {
    // 签到数据接收监听
    eventBus.$on('signInDataSent', (signInfo) => {
      this.handleSignInfo(signInfo);
    });
    // 单单返弹层展示监听
    eventBus.$on('showAwardGuidePopup', () => {
      this.showAwardGuidePopup();
    });
    eventBus.$on('haveFinishSignDoubleAdv', () => {
      this.doubleInformation = null;
    });
  },
  methods: {
    // 展示单单返引导弹窗
    showAwardGuidePopup() {
      const awardGuide = Storage.getItem(STORAGE_KEY_SHOW_AWARD_GUIDE);
      if (awardGuide !== 'YES') {
        this.getTaskAwardList();
      }
      // 奖励领取仅展示一次
      Storage.setItem(STORAGE_KEY_SHOW_AWARD_GUIDE, 'YES');
    },
    // 点击奖励
    handleAwardClick(awardStatus) {
      if (awardStatus === AWARD_COIN_STATUS.NORMAL) {
        this.getTaskAwardList();
      } else {
        this.$emit('awardClick');
      }
    },
    // 获取单单返任务奖励列表
    async getTaskAwardList() {
      Loading.show();
      const { taskAwardList, ariesData } = await getTaskAwardListData({
        isVip: this.currentlyIsVip,
      });

      if (taskAwardList.length !== 0) {
        this.taskAwardList = taskAwardList;
        this.taskAwardExtInfo = ariesData;
        this.awardGuidePopupVisible = true;
      }
      Loading.close();
    },
    // 关闭单单返奖励引导弹窗
    handleAwardGuidePopupClose() {
      this.awardGuidePopupVisible = false;
    },
    // 处理签到信息
    handleSignInfo(info) {
      const {
        bonusList = [],
        currentlyIsVip,
        moduleInfo,
        repeatSignDesc,
        signInUpdateTipsSwitch = false,
      } = info;
      // 处理签到计划列表
      const { signInPopupList } = signInListAdapter(bonusList);
      const nextSignData = bonusList.find((item) => item.didSign === false);

      // 处理moduleInfo
      let bannerAdvertisementUnitId = '';
      let bannerTaskRelationCouponInfo = {};

      if (moduleInfo && moduleInfo.length > 0) {
        const signInModule = moduleInfo
          .find((item) => item.moduleKey === FULI_MODULE.welfare_attendance_new);
        if (signInModule) {
          bannerAdvertisementUnitId = signInModule.bannerAdvertisementUnitId || '';
          bannerTaskRelationCouponInfo = signInModule.bannerTaskRelationCouponInfo || {};
        }
      }
      this.doubleInformation = {
        bannerAdvertisementUnitId,
        bannerTaskRelationCouponInfo,
      };

      // 数据更新
      this.signInList = signInPopupList;
      this.currentlyIsVip = currentlyIsVip;
      this.nextSignData = nextSignData || bonusList[0] || {};
      this.repeatSignDesc = repeatSignDesc;
      // 是否在支付宝已签到
      this.isSignedAlipay = !!repeatSignDesc;
      // 是否开启签到更新提示
      this.showUpdateTips = signInUpdateTipsSwitch;
    },
    // 签到气泡点击
    async handleSignBubbleClick() {
      if (this.signInList.length === 0) return;
      const taskScene = this.taskScene();

      // 展示新版签到弹窗
      if (taskScene === WELFARE_VERSION.NEW_TASK_SCENE_V2) {
        try {
          const version = await getVersion();
          if (
            this.showUpdateTips
            && this.isSignedAlipay
            && compareVersions(version, '6.98.20') === -1
          ) {
            Toast.show('App版本过低，请升级后重试');
            return;
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.info('showUpdateTips => error', safeJsonStringify(error));
        }

        loadAndShowSignPopup({
          isVip: this.currentlyIsVip,
          signInPopupList: this.signInList,
          isRepeatSigned: this.isSignedAlipay,
          isPureVersion: this.pureVersion,
          ...(this.doubleInformation || {}),
        });
        this.doubleInformation = null;
      }
      // 展示旧版签到弹窗
      if (taskScene === WELFARE_VERSION.NEW_TASK_SCENE) {
        if (this.isSignedAlipay) {
          Toast.show(this.repeatSignDesc);
        }
        eventBus.$emit('showCheckInModal');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-bubbles-container {
  display: flex;

  .sign-in-bubble-area {
    position: relative;
    z-index: 1;
    margin-right: 0.16rem;
  }
}
</style>
